import { createAxiosInstance } from "@mobsuccess-devops/axios-instance";
const instance = createAxiosInstance();
export function msAxiosInstance(config, options) {
    return instance.msAxiosInstance(config, options);
}
export const MSAxiosInstance = instance.MSAxiosInstance;
